var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLanguage } from "./context/LanguageContext";
import "../styles/PreparingOverlay.css";
import Footer from "./common/Footer";
export default function PreparingOverlay(_a) {
    var _b = _a.videoSrc, videoSrc = _b === void 0 ? "./video_intro_usine_virtuelle.mp4" : _b, messageOverride = _a.messageOverride, _c = _a.dimBackground, dimBackground = _c === void 0 ? false : _c, _d = _a.videoBackground, videoBackground = _d === void 0 ? true : _d, _e = _a.isFirstLoading, isFirstLoading = _e === void 0 ? true : _e;
    var language = useLanguage().language;
    var videoRef = useRef(null);
    var _f = useState(null), texts = _f[0], setTexts = _f[1];
    useEffect(function () {
        fetch("./Ressources/textes/loader_".concat(language, ".json"))
            .then(function (r) { return r.json(); })
            .then(function (data) { return setTexts(data); })
            .catch(function (err) {
            console.error("Erreur chargement textes PreparingOverlay:", err);
            setTexts(null);
        });
    }, [language]);
    useEffect(function () {
        var _a;
        // Tente l’autoplay (silencieux)
        (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play().catch(function () {
            // Certains navigateurs bloquent l’autoplay, pas grave : la vidéo démarrera au premier user-gesture
        });
    }, []);
    var message = useMemo(function () {
        if (messageOverride)
            return messageOverride;
        if (!texts)
            return ""; // en attendant le json
        return isFirstLoading ? texts.firstLoading : texts.standardLoading;
    }, [messageOverride, texts, isFirstLoading]);
    return (_jsxs("div", __assign({ className: "preparing-overlay", role: "status", "aria-live": "polite" }, { children: [videoBackground && (_jsx("video", { className: "preparing-video", ref: videoRef, src: videoSrc, autoPlay: true, muted: true, loop: true, playsInline: true })), dimBackground && _jsx("div", { className: "preparing-dim" }), _jsxs("div", __assign({ className: "preparing-content" }, { children: [_jsx("h2", __assign({ className: "preparing-title" }, { children: message })), _jsx("div", __assign({ className: "dot-spinner", "aria-label": "Loading" }, { children: Array.from({ length: 8 }).map(function (_, i) { return (_jsx("span", { className: "dot dot-".concat(i + 1) }, i)); }) }))] })), _jsx(Footer, {})] })));
}
